// TODO Move Trade inputs to reusable place
import { SwitchLabel as BaseSwitchLabel, SwitchWrapper } from 'components/Switch'
import React from 'react'
import styled from 'styled-components'
import { color, screenWidth } from 'utils/styledHelper'

import TicketAmountInput from '../Trade/Ticket/AmountInput'
import TicketLimitPriceInput from '../Trade/Ticket/LimitPriceInput'

export const Wrapper = styled.div`
  padding: 2rem;
  width: 30rem;
  background: ${color('dark700')};
  color: ${color('white')};
  border-radius: 0.5rem;

  @media only screen and (max-width: ${screenWidth('sm')}) {
    padding: 4rem 1rem 1rem 1rem;
    width: auto;
    border-radius: 0;
  }
`

export const Header = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 150%;
  display: flex;
  gap: 1rem;
`

export const Footer = styled.footer`
  display: flex;
  flex-direction: row;
  margin-top: 2rem;
  gap: 1rem;

  & > * {
    flex: 1;
  }
`

export const MarginModalSwitchWrapper = styled(SwitchWrapper)`
  background: ${color('dark600')};
`

const SwitchLabel = styled(BaseSwitchLabel)`
  font-size: 0.875rem;
  padding: 4px 8px;
`
export const MarginModalSwitchLabel = (props) => (
  <SwitchLabel
    activeColor={color('dark900')}
    hoverColor={color('dark700')}
    regularColor={color('dark600')}
    selectedColor={color('dark900')}
    selectedTextColor={color('primaryMuted')}
    textColor={color('dark100')}
    {...props}
  />
)

export const LimitPriceInput = styled(TicketLimitPriceInput)`
  input {
    background: ${color('dark800')};
  }

  .limit-input-drawer {
    background: ${color('dark900')};
  }
`

export const AmountInput = styled(TicketAmountInput)`
  input {
    background: ${color('dark800')};
  }

  .amount-input-drawer {
    background: ${color('dark900')};
  }
`
